const styles = (theme) => ({
  root: {
    background: "var(--wws-shell)",
    minHeight: "calc(100vh - 92px)",
    padding: theme.spacing(6, 3, 10),
  },
  container: {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    minHeight: "calc(100vh - 180px)",
  },
  eyebrow: {
    color: "var(--wws-accent)",
    fontFamily: '"Barlow Condensed", sans-serif',
    fontSize: "1rem",
    fontWeight: 700,
    letterSpacing: "0.22em",
    marginBottom: theme.spacing(2),
    textTransform: "uppercase",
  },
  title: {
    color: "var(--wws-primary)",
    fontFamily: '"Barlow Condensed", sans-serif',
    fontSize: "clamp(3rem, 7vw, 5rem)",
    fontWeight: 700,
    lineHeight: 0.95,
    marginBottom: theme.spacing(2.5),
    textTransform: "uppercase",
  },
  text: {
    color: "rgba(21, 36, 66, 0.76)",
    fontFamily: '"Manrope", sans-serif',
    fontSize: "1.05rem",
    lineHeight: 1.8,
    marginBottom: theme.spacing(4),
    maxWidth: 560,
  },
  button: {
    background: "var(--wws-accent)",
    borderRadius: 999,
    boxShadow: "none",
    color: "var(--wws-paper)",
    fontFamily: '"Barlow Condensed", sans-serif',
    fontSize: "1rem",
    fontWeight: 700,
    letterSpacing: "0.1em",
    padding: theme.spacing(1.4, 3),
    textTransform: "uppercase",
    "&:hover": {
      background: "var(--wws-accent-deep)",
      boxShadow: "none",
    },
  },
});

export default styles;
